import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=71f67bf8&scoped=true"
import script from "./ReportList.vue?vue&type=script&lang=js"
export * from "./ReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f67bf8",
  null
  
)

export default component.exports